import { env } from '../utils'

export const FIND_MY_SCHOOL_API = env('REACT_APP_FIND_MY_SCHOOL_URL')
